export default "__VITE_ASSET__D5iJ55m7__"